<mat-dialog-content class="mat-typography">
  <h3>Débannir un utilisateur</h3>
  <p>
    Voulez-vous vraiment débannir cet utilisateur ? Il pourra à nouveau se
    connection à l'application.
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Annuler</button>
  <button mat-button [mat-dialog-close]="true">Débannir</button>
</mat-dialog-actions>
